<div class="generator-container">
  <mat-spinner diameter="40"></mat-spinner>
  <p class="redirect-message">{{ 'generator.redirecting' | translate }}</p>
</div> 